









































import { Vue, Component, Prop, Watch } from "vue-property-decorator";

// Types
import { IProduct } from "@/models/products";

@Component
export default class CloseIntervalField extends Vue {
  // Props

  @Prop({ required: true })
  public value!: IProduct["close_interval"];

  @Prop({ required: true })
  public brandValue!: IProduct["close_interval"];

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data
  public hasBrandValue = false;
  public closeIntervalValue: IProduct["close_interval"] = null;

  // Methods

  public onHasBrandValueChange() {
    if (this.hasBrandValue) {
      this.closeIntervalValue = this.brandValue;
    }

    this.onCloseIntervalValueChange();
  }

  // Watchers

  @Watch("closeIntervalValue")
  public onCloseIntervalValueChange() {
    this.$emit("input", this.hasBrandValue ? null : this.closeIntervalValue);
  }

  @Watch("value", { immediate: true })
  public onPassedValueChange() {
    this.hasBrandValue = this.$_.isNull(this.value);
    this.closeIntervalValue = this.hasBrandValue ? this.brandValue : this.value;
  }
}
